import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { GlobalSettingsService } from './globalSettings.service';
import { AuthService } from 'app/services/authentication/auth.service';
import { PlatformLoginService } from 'app/services/platform-login/platform-login.service';

@Injectable()
export class RootGuard  {
	constructor(
		private router: Router,
		private authService: AuthService,
		private globalSettings: GlobalSettingsService,
		private platformLoginService: PlatformLoginService
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (this.authService.isAuthenticated()) {
			const rolePath = this.globalSettings.rolePath();
			this.router.navigate([ `/${rolePath}/home` ]);
			return true;
		}

		this.platformLoginService.navigateToLogin();
		return false;
	}
}
